import { useField } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import { Row } from 'uiComponents/flex'
import ToggleFieldFormik from 'uiComponents/input/toggle/toggleFieldFormik'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { useTranslation } from 'translations'

interface ToggleMapEnabledProps {
    onChange: () => void
}

const ToggleMapEnabled = ({ onChange }: ToggleMapEnabledProps) => {
    const { t } = useTranslation()
    const [{ value }, {}, { setValue }] = useField('enabled')
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false)
    const [blockDialog, setBlockDialog] = useState<boolean>(true)
    const texts = {
        title: value ? t('venue.parkMap.mapDetails.activateTitle') : t('venue.parkMap.mapDetails.deactivateTitle'),
        text: value ? t('venue.parkMap.mapDetails.activateText') : t('venue.parkMap.mapDetails.deactivateText'),
    }

    useEffect(() => {
        if (blockDialog) {
            setBlockDialog(false)

            return
        }

        setShowConfirmationDialog(true)
    }, [value])

    const onConfirm = useCallback(() => {
        setShowConfirmationDialog(false)
        onChange()
    }, [])

    const onCancel = useCallback(() => {
        setBlockDialog(true)
        setShowConfirmationDialog(false)
        setValue(!value)
    }, [value])

    return (
        <Row>
            {showConfirmationDialog && (
                <ConfirmationDialog
                    title={texts.title}
                    text={texts.text}
                    buttonText={
                        value ? t('venue.parkMap.mapDetails.activate') : t('venue.parkMap.mapDetails.deactivate')
                    }
                    destructive
                    onCancel={onCancel}
                    onConfirm={onConfirm}
                />
            )}
            <ToggleFieldFormik
                name="enabled"
                label={t('venue.parkMap.mapDetails.activate')}
                id="enabled"
                variant="inline"
            />
        </Row>
    )
}

export default ToggleMapEnabled
